module.exports = __webpack_public_path__ + "img/0110.2afd1ac6.jpg";